/*eslint-disable react/no-danger*/
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { replace } from 'react-router-redux';

import './style.scss';
import { ForumThreadShape } from 'entities';
import { getForumThread } from 'selectors';
import * as actions from 'actions';
import { hasEnded } from 'forumLiveStatus';

class ForumLiveThreadLobby extends Component {

  componentDidMount() {
    this.props.onDidMount && this.props.onDidMount();
  }

  componentDidUpdate() {
    this.props.onDidUpdate && this.props.onDidUpdate(this.props.forumThread);
  }

  render() {
    const { forumThread, startsInInfo } = this.props;
    const startTime = moment(forumThread.liveStart).format('hh:mm a');

    return (
      <div className="ForumLiveThreadLobby wrapper-full is-collapsed is-collapsed-top">
        <div className="live-placeholder wrapper-small is-padded-top">
          <div className="text-center">
            {forumThread && <h1>{forumThread.title}</h1>}
            <div className="icon-live-holder"></div>
          </div>

          {!forumThread && <h4 className="text-center">{__('members.forum.loading')}</h4>}

          {forumThread && <h4 className="text-center">{`This is a live forum which will start ${startsInInfo}`}</h4>}
          {forumThread && <p className="text-center" dangerouslySetInnerHTML={{ __html: `At <time>${startTime}</time> you can discuss the topic with other people at the same time. It’s like a group chat. You'll be redirected when the discussion starts.` }} />}
        </div>
      </div>
    );
  }
}

ForumLiveThreadLobby.propTypes = {
  forumThread: ForumThreadShape,
  startsInInfo: PropTypes.string,
  onDidMount: PropTypes.func,
  onDidUpdate: PropTypes.func
};

const mapStateToProps = (state, props) => {
  const forumThread = getForumThread(state, props.params.id);
  const startsInInfo = forumThread && moment(forumThread.liveStart).fromNow();

	return {
    forumThread,
    startsInInfo // It's here and not in the component in order to rerender to compoennt on TIME_REFRESH action.
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onDidMount: () => {
      dispatch(actions.forumThreadProfileFetch(props.params.id));
    },
    onDidUpdate: forumThread => {
      if(forumThread && hasEnded(forumThread)) {
        dispatch(replace(`forum/threads/${props.params.id}`));
      }
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForumLiveThreadLobby);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Forum/ForumLiveThreadLobby/index.js
 **/